/** Matches BE serializer order: case-insensitive name, then id. */
const sortRopaCategories = <T extends { id?: number; name: string }>(categories: T[]): T[] =>
  [...categories].sort((left, right) => {
    const byName = left.name.localeCompare(right.name, undefined, { sensitivity: 'base' });
    if (byName !== 0) return byName;

    const leftId = left.id ?? Number.MAX_SAFE_INTEGER;
    const rightId = right.id ?? Number.MAX_SAFE_INTEGER;
    return leftId - rightId;
  });

export default sortRopaCategories;
